// User facing project names
// NOTE: Duplicates must have a space after them, or there will be bugs
const projectList = {
	// usa: "Biotech", // Doesn't work with the modern API
	africom: "Baghdad",
	asksage: "Ask Sage",
	brasilia: "DOS-Brasilia",
	china: "Platform 2023 (v135B)",
	craftsman: "CRAFTSMAN",
	aatf: "Atmospherics",
	gec: "GEC",
	iraq: "Iraq",
	islamabad: "Islamabad",
	afghanistandemo: "Afghanistan",
	afghanistanDFAT:"Afghanistan - DFAT",
	kabul: "Kabul",
	mf: "Metropolis Festival",
	mf_translate: "MF - translated",
	nest: "NEST - Thailand",
	nest_mongolia: "NEST - Mongolia",
	politics2020: "US Politics 2020",
	oseRussia: "Russia",
	oseKabul: "OSE - AfPak Newsdesk",
	oseAusChina: "OSE - Australia/China",
	australia2022: "Platform 2022 (V259-REL)",
	koala: "Koala",
	venezuela: "Venezuela",
	dcos: "DCOS",
};

export default projectList;
